import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const FILE_URL = (path) => `${API}/files/${path}`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
